import { pr, React, theme } from "aaa";
import { ui } from "components/util/uiHelpers";

export const ThirdPartyPortrait = () => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: ui.isDarkMode ? "rgba(25, 156, 249, 0.2)" : "#EEF4FE"
            }}
        >
            <pr.IconUser style={{ color: "#135EE2", width: 24, height: 24 }} />
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/tpp/TPPMember.tsx